import { WorkBook } from 'xlsx-js-style';
import { ExcelTemplate } from '../../interfaces';
import * as XLSX from 'xlsx-js-style';
import { setColumnWidth, withHeaderStyling } from '../../utils';
import { fitToColumn } from '../financial-statement/utils';
import { getPreparedData } from './mapping';
import { AppreciationAtCostExcelWrapper } from 'src/app/domain/pp/component/sub/appreciation-at-cost/appreciation-at-cost.component';

export class PpAnalysisAtCostTemplate implements ExcelTemplate {
  export(data: AppreciationAtCostExcelWrapper): WorkBook {
    const book = XLSX.utils.book_new();
    const sheet = this.getSheet(data);
    XLSX.utils.book_append_sheet(book, sheet);
    return book;
  }

  private getSheet(exportExcelData: AppreciationAtCostExcelWrapper): XLSX.WorkSheet {
    const headersForDisplay = this.getHeadersForDisplay();
    const headersForLogic = this.getHeadersForLogic();

    const preparedData = getPreparedData(exportExcelData, headersForLogic, headersForDisplay);
    const whiteSpaceIndex = [3, 7, 11, 15];
    const sheet = {
      ...XLSX.utils.aoa_to_sheet(preparedData),
      '!cols': fitToColumn(preparedData),
    };
    whiteSpaceIndex.forEach((index) => setColumnWidth(sheet, index, 1));
    return withHeaderStyling(sheet);
  }

  private getHeadersForDisplay = () => ['Company name', 'Status', 'Initial investment', null,
    'Investment', 'Value', 'MOIC', null,
    'Investment', 'Value', 'MOIC', null,
    'Investment', 'Value', 'MOIC', null,
    'Investment%', 'Value%'];

  private getHeadersForLogic = () => ['Company name', 'Status', 'Initial investment', null,
    'Investment(0)', 'Value(0)', 'MOIC(0)', 'empty(0)',
    'Investment(1)', 'Value(1)', 'MOIC(1)', 'empty(1)',
    'Investment(2)', 'Value(2)', 'MOIC(2)', 'empty(2)',
    'Investment%', 'Value%'];
}
